import { useContext } from 'react';
import { ProductTourContext } from '../components/tour/ProductTourProvider';

export function useProductTour() {
    const ctx = useContext(ProductTourContext);
    if (!ctx) {
        throw new Error('useProductTour must be used within ProductTourProvider');
    }
    return ctx;
}

/** Safe for components that may render outside the provider (returns no-ops). */
export function useProductTourOptional() {
    return useContext(ProductTourContext);
}
